module.exports = {
	home: {
		bindAccountTitle: 'アカウントを連携する',
		getNameTitle: 'アカウント名を設定',
		linkAccountTitle: 'アカウントを連携する',
		yinjicode: '引き継ぎID',
		changePsw: 'パスワードの設定/変更',
		cancelAccountTitle: 'ゲストアカウント削除',
		// loginDeviceTitle: 'デバイス管理',
		bindAccountBtn: 'FUNDOLLアカウントを連携する',
		accountTitle: 'アカウント',
		checkAccountBtn: 'アカウントを切り替える',
		changePswTitle: 'パスワードを変更',
		clickPswTitle: '変更をクリック',
		binded: '連携済み',
		goChangeBind: 'メールアドレスを変更する',
		goBind: '連携に進む',
		emailBindTitle: 'メールアドレスを連携する',
		privacyTitls: 'プライバシーポリシー',
		FAQTitle: 'よくある質問',
		kefu: 'カスタマーサポート',
		logOffTitle: 'アカウント削除',
		accountTitle1: 'アカウント名',
		accountIdTitle: 'アカウント',
		changeEmailBtn: '連携メールアドレスの変更',
		touristName: 'ゲストユーザー',
		touristTitle: '認証済み',
		logOut: 'ログアウト',
		setNameTitle: 'アカウント名を入力してください。',
		bindAccountsTips:
			'すでにキャラクターが存在しているアカウントに連携できませんので、ご注意ください。',
		gotoBindBtn: '連携に進む',
		query: 'セルフサービス',
	},
	toast: {
		verifycodeBtn: '取得',
		verifycodeBtn2: '再取得',
		comfirmBtn1: '確定',
		comfirmBtn2: 'キャンセル',
		emailPlaceholder: 'メールアドレスを入力してください。',
		setNamePlaceholder: 'アカウント名を入力してください。',
		setNameTitls: '7~16の半角英数の混在でご入力ください。',
		verifyTitle: '認証コードを入力してください。',
		pswTitle1: '新しいパスワードを入力してください。',
		pswTitle2: '新しいパスワードを再度入力してください。',
		comfirmPswTips: '入力されたパスワードが一致しません。',
		verifypswTips:
			'パスワードは6文字以上18文字以下で作成してください。（スペースを含まない）',
		newverifypswTips: 'パスワードを入力してください。',
		verifyemailTips: 'フォーマットが正しくないため、再度入力してください。',
		noEmail: '連携するメールアドレスを入力してください。',
		longTime: ' 一定時間操作されなかったため、再認証が必要です。',
		noInfo: '情報がまだ収集されていません。',
		binded: '連携済みのアカウントです。お心当たりがない場合は、カスタマーサポートにお問い合わせください。',
		banCancelAccount:
			'当該連携アカウント{name}でログインしたため、一度ログアウトして、他の連携アカウントでログインしてから再度解除をお試しください。',
		noEmail1: 'メールアドレスを入力してください。',
		logout1: 'ログアウトしました。',
	},
	logoff: {
		logoffTipsText1:
			'1.在您提交账号注销申请次日起的15日内，我们将处理您的注销申请，若您在15日届满前重新登录该游戏账号，则注销申请将被自动撤销。',
		logoffTipsText2: '2.账号注销成功后，您将永久无法使用该游戏账号。',
		logoffTipsText3:
			'3.如果您有任何疑问，请在工作时间（周一到周日，10:00-19:00）联系客服咨询。',
		logoffTipsBtn: '削除する',
		text1: 'あなたのアカウントの安全を守るために',
		text2: 'アカウントの削除申請を受理しました。',
		text11: 'アカウントの削除申請を受理しました。',
		text3: `{time}に提出されたアカウントの削除申請を受領しました。アカウントを完全に削除するプロセスが開始されます。`,
		text4: `あなたのアカウントは{time}に削除されます。 それ以前にこちらのアカウントにログインする場合、アカウントの削除処理は自動的に取り消されます。`,
		text5: 'ヒント',
		text9: 'サーバー',
		text7: 'キャラクター',
		text8: 'レベル',
		text10: 'アカウントの削除に関する注意事項をご確認ください。',
		text6: '削除を確認すると、ゲストアカウントは新しいアカウントにリセットされ、現在のゲーム記録は一切復元できませんのでご注意ください。',
		tourText2: 'ゲーム',
		tourText3: 'キャラクター',
		tourText4: 'UID',
		tourText5: '調査官レベル',
		logoffScuessTips:
			'アカウントの削除申請を行ったため、ログインが無効となりました。',
		agreementTips: '{name}を閲覧して、同意しました。',
		buttonText: '規約を閲覧する',
		buttonText1: '削除に進む',
	},
	title: {
		title: 'ユーザーセンター',
		title1: 'プライバシーポリシー',
		title2: 'よくある質問',
		title3: 'カスタマーサポート',
		title4: 'セキュリティ検証',
		title5: 'アカウントを連携する',
		title6: 'メールアドレスを連携する',
		title7: 'パスワード変更',
		title8: 'アカウント削除に関する注意事項',
		title9: 'アカウント削除に関する注意事項',
		title10: 'アカウント名を設定',
		title11: '連携を解除する',
		title12: 'アカウント連携',
		// title13: 'アカウント削除に関する注意事項',
		title14: 'アカウント削除',
		title15: 'アカウント削除に関する注意事項',
		title16: 'デバイス管理',
		title18: 'メールアドレスの変更',
		title19: 'アカウント名設定',
		netError:
			'ネットワークエラーが発生しました。ネットワーク接続を確認してください。',
		title20: 'アカウント削除規約',
		title21: 'プライバシーポリシー',
		title22: '利用規約',
		title23: '引き継ぎID',
		title24: 'データ引き継ぎ',
		title25: '引き継ぎIDを確認',
	},
	verifyText: {
		titleTxt1:
			'アカウントの安全を守るため、新しいアカウント名を設定する前に、メールアドレスの認証確認を行う必要があります。',
		titleTxt2:
			'アカウントの安全を守るため、新しいアカウントを連携する前に、メールアドレスの認証確認を行う必要があります。',
		titleTxt3:
			'アカウントの安全を守るため、パスワードの変更を行う前に、メールアドレスの認証確認を行う必要があります。',
		titleTxt4:
			'アカウントの安全を守るため、デバイス管理を行う前に、メールアドレスの認証確認を行う必要があります。',
		titleTxt5:
			'アカウントの安全を守るため、連携されているメールアドレスの変更を行う前に、メールアドレスの認証確認を行う必要があります。',
		titleTxt6:
			'アカウントの安全を守るため、連携解除を行う前に、メールアドレスの認証確認を行う必要があります。',
		title1: 'メールアドレス',
	},
	successText: {
		goBack: '戻る',
		successTitle1: '連携成功',
		successTitle2: '解除成功',
		successTitle3: 'メールアドレスの変更に成功しました。',
		successTitle4: '設定成功',
	},
	bindAccountText: {
		text1: '解除',
		text2: '連携',
		text3: '既存のアカウント',
		text4: '登録して連携する',
		text5: 'アカウントの安全を守るため、アカウントを連携する前に、連携されているメールアドレスをご確認ください。',
		text6: 'FUNDOLLアカウントを連携する',
		text7: 'メールアドレス/アカウント名を入力してください',
		text8: '連携済みのアカウントです。お心当たりがない場合は、カスタマーサービスにお問い合わせください。',
	},
	preamble: {
		tx1: '新しい端末にデータを引き継ぐと、元端末ではご利用できなくなります。',
		tx2: 'データ引き継ぎ',
		tx3: '他の端末にデータを引き継ぐと、こちらの端末でのデータは削除されますのでご注意ください。',
		tx4: '引き継ぎIDを確認',
		tx5: '引き継ぎIDを入力',
		tx6: 'パスワード',
		tx7: '（引き継ぎパスワードが設定されていない場合は、この項目を空白のままにしてください）',
		tx8: '引き継ぎパスワードを入力',
		tx9: '現在の端末の引き継ぎIDは使用できません。',
		tx10: 'キャラクターが存在しません。',
		tx11: '「引き継ぐ」をタップ/クリックした後は、元の端末ではこちらのキャラクターでログインできません。',
		tx12: '引き継ぐ',
		tx13: '引き継ぎ完了',
		tx14: '(一度設定された引き継ぎIDのパスワードは変更できません。)',
		tx15: 'コピー',
		tx16: 'パスワード設定完了',
		tx17: 'コピーしました！',
		tx18: 'コピーに失敗しました。手動でコピーしてください。',
	},
};
